import { css } from '@/styled-system/css';

export const widgetStyles = css.raw({ display: 'flex', flexDirection: 'column', gap: 'default' });

export const headerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
});

export const headingStyles = css.raw({ textStyle: { base: 'body-bold', lg: 'heading-xs' } });

export const tileRowStyles = css.raw({ display: 'flex', gap: 'default' });

export const tileContentStyles = css.raw({ display: 'flex', flexDirection: 'column', alignItems: 'center' });

export const tileLinkStyles = css.raw({ display: 'block', color: 'inherit', textDecoration: 'none' });
